// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  browserSessionPersistence,
  connectAuthEmulator,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase configuration.
// Do not set measurementId or call getAnalytics(): these sites share a Firebase
// project for Auth/Firestore, and Analytics would send events to the project's
// linked GA4 property (Davis) instead of VITE_FIREBASE_MEASUREMENT_ID. Site
// analytics goes through GTM.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Prefer localStorage so Astro SEO pages can detect the session without IndexedDB.
// Existing IndexedDB sessions are migrated on next SPA load.
// No popupRedirectResolver here: passing one makes auth init await the gapi
// iframe (apis.google.com + firebaseapp.com) before onAuthStateChanged fires,
// on every page load. signInWithPopup passes the resolver itself instead.
function createAuth() {
  try {
    return initializeAuth(app, {
      persistence: [
        browserLocalPersistence,
        indexedDBLocalPersistence,
        browserSessionPersistence,
      ],
    });
  } catch {
    return getAuth(app);
  }
}

// Initialize services
export const auth = createAuth();
if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
}
export const db = getFirestore(app);

export default app;
